import React, { useEffect } from 'react';
import logo from 'assets/images/logo-2-color.svg';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import useAsyncFetch from 'hooks/async-fetch';
import trustedEmailService from 'services/api/customer/trusted-email-service';
import classNames from 'classnames';
import PageLoader from 'components/Loaders/PageLoader';
import styles from './TrustedTrustedEmailConfirmPage.module.scss';

const TrustedEmailConfirmPage = () => {
  const [t] = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [resultText, setResultText] = React.useState<string | null>(null);

  const [confirmTrustedEmail, confirmLoading, success] = useAsyncFetch({
    async asyncFunc() {
      await trustedEmailService.confirmTrustedEmail(token || '');
      return true;
    },
    errorHandler: ({ errMessage }) => {
      setResultText(errMessage);
    },
    initialState: false,
  });

  useEffect(() => {
    if (token) {
      confirmTrustedEmail();
    }
  }, [token]);

  if (!token) {
    return <Navigate to="/" replace />;
  }
  if (confirmLoading) return <PageLoader />;

  return (
    <main className={styles.trustedEmailConfirm}>
      <div className={styles.logo}>
        <img src={logo} width={200} height={80} alt="pro-data" />
      </div>
      <h1 className="font-heading mb-0">{t('trusted_email.confirmation_email')}</h1>
      {success && <p>{t('trusted_email.confirmation_email_success')}</p>}
      {!success && <p>{resultText}</p>}
      <Link className={classNames(styles.backMainBtn, 'btn btn-outline-secondary w-100')} to="/" replace qa-element="to-main">{t('common.back_to_main')}</Link>
    </main>
  );
};

export default TrustedEmailConfirmPage;
